<template src="./main.html"></template>

<script>
import CalculatedModal from '../modals/calculated/calculated'
import PreviewModal from '../modals/preview/preview'
import RightBar from '../rightbar/rightbar'
import SelectProductModal from '../modals/selectproduct/selectproduct'
import VariablesModel from '../modals/variables/Variables'
import Vue from 'vue'
import auth from '../../../helpers/auth'
import axios from "axios";
import customer from '../modals/customer/customer'
import {store} from '../../../store/store'
import { isCalculatedQuoteTask } from '../../../helpers/calculatedQuoteDisplay'
import { normalizeTemplate } from '../../../helpers/taskTypes'
import CompareDrawer from '../compare/CompareDrawer'
import ComparePreviewModal from '../compare/ComparePreviewModal'
import Breadcrumbs from '../../common/Breadcrumbs.vue'
import QuoteTaskTile from '../../common/QuoteTaskTile.vue'
import moment from 'moment'
import { clone as deepClone } from '../../../helpers/clone'
import { TASK_PRICE_TYPES } from '../../../helpers/taskPricing'
import {
    DEFAULT_QUOTE_VALIDITY_DAYS,
    addDaysYmd,
    quoteValidityDaysFromSettings
} from '../../../helpers/documentDefaultDays'

const today = moment().format('YYYY-MM-DD')
const dueDefault = addDaysYmd(today, DEFAULT_QUOTE_VALIDITY_DAYS)

export default {
    name: 'QuoteMain',
    components: {
        'app-calculated-modal': CalculatedModal,
        'app-customer-modal': customer,
        'app-preview-modal': PreviewModal,
        'app-right-bar': RightBar,
        'app-select-product-modal': SelectProductModal,
        'app-variables-modal': VariablesModel,
        'app-addon-modal': require('../modals/addons/Addons.vue').default,
        'app-compare-drawer': CompareDrawer,
        'app-compare-preview-modal': ComparePreviewModal,
        'app-breadcrumbs': Breadcrumbs,
        'app-quote-task-tile': QuoteTaskTile
    },
    data: function () {
        // Single array for quote.items and quoteItems so pushes stay visible in the sidebar/preview
        // before quote.items = quoteItems runs (avoids stale empty quote.items vs populated quoteItems).
        const quoteLineItems = []
        return {
            subCategory: null,
            catalogSearchText: '',
            catalogViewMode: 'browse',
            breadcrumbSegments: [],
            categoryTiles: [],
            loadingCategories: false,
            isNarrowScreen: false,
            _mediaQuery: null,
            _mediaHandler: null,
            speechRecording: false,
            _speechRec: null,
            _speechMaxTimer: null,
            _speechVisibilityHandler: null,
            micIconOff: require('../../../assets/img/quote/icn_mic-off.svg'),
            micIconOn: require('../../../assets/img/quote/icn_mic-on.svg'),
            task: {
                calculation: [],
                sell_price: 0
            },
            tasks: {
                default: [],
                company: []
            },
            addons: {
                default: [],
                company: []
            },
            products: null,
            expenses: null,
            quote: {
                number: null,
                contact_id: null,
                callout_fee: 0,
                contact: {},
                gst_total: '0.00',
                sub_total: '0.00',
                total: '0.00',
                labour_time_hours: 0,
                labour_time_minutes: 0,
                items: quoteLineItems,
                status_id: 1,
                terms: '',
                date: today,
                due_date: dueDefault,
                discount: 0,
                discount_override: 0,
                discount_mode: null,
                discount_preset_id: null,
                discount_title: null,
                discount_description: null,
                discount_type: null,
                discount_value: null,
                discount_amount_applied: 0
            },
            quoteItems: quoteLineItems,
            spModalVisible: false,
            calculatedModalVisible: false,
            customerModalVisible: false,
            rightSidebarKey: 1,
            variablesModalVisible: false,
            loading: false,
            editingTask: false,
            addonModalVisible: false,
            defaultTaskPriceType: null,
            quoteValidityDays: DEFAULT_QUOTE_VALIDITY_DAYS,
        }
    },
    computed: {
        searchPlaceholder: function () {
            return this.isNarrowScreen
                ? 'How can SmardieAI help?'
                : 'Use SmardieAI to find something or help start a quote.'
        },
        searchInputPlaceholder: function () {
            if (this.speechRecording) return 'Listening...'
            return this.searchPlaceholder
        },
        speechRecognitionAvailable: function () {
            return typeof window !== 'undefined' &&
                !!(window.SpeechRecognition || window.webkitSpeechRecognition)
        },
        catalogTasksList: function () {
            const d = (this.tasks && Array.isArray(this.tasks.default)) ? this.tasks.default : []
            const c = (this.tasks && Array.isArray(this.tasks.company)) ? this.tasks.company : []
            return d.concat(c)
        },
        /** Root = viewing top-level category tiles only (not drilled in, not search). */
        isAtCategoryTreeRoot: function () {
            return this.catalogViewMode === 'browse' &&
                !this.subCategory &&
                (!this.breadcrumbSegments || this.breadcrumbSegments.length === 0)
        },
        comparePreviewOpen: function () {
            return this.$store.getters['compare/comparePreviewOpen']
        }
    },
    methods: {
        editTask: function (task) {
            this.editingTask = true;
            this.task = task
            this.variablesModalVisible = true
        },
        calculateTaskCost: function (task) {
            // Align with Variables.vue `price` / `materialCost`: labour × multiplier × qty + (materials + vars) × qty
            const isTimeBased = task.type === 1 || task.type === 'time_based'
            if (!isTimeBased) {
                return task.sell_price
            }

            const sellRaw = task.sell_price != null && task.sell_price !== '' ? parseFloat(task.sell_price) : NaN
            if (Number.isFinite(sellRaw) && sellRaw > 0) {
                task.sell_price = sellRaw.toFixed(2)
                return task.sell_price
            }

            const qty = parseFloat(task.qty)
            const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1
            const multRaw = task.location != null ? task.location : (task.hourly_rate_multiplier != null ? task.hourly_rate_multiplier : 1)
            const safeMult = Number.isFinite(parseFloat(multRaw)) && parseFloat(multRaw) > 0 ? parseFloat(multRaw) : 1

            let materialSum = 0
            if (task.materials && task.materials.default) {
                task.materials.default.forEach(function (material) {
                    materialSum += (parseFloat(material.sell_price) || 0) * (parseFloat(material.qty) || 0)
                })
            }
            if (task.materials && task.materials.company) {
                task.materials.company.forEach(function (material) {
                    materialSum += (parseFloat(material.sell_price) || 0) * (parseFloat(material.qty) || 0)
                })
            }
            let variableSum = 0
            if (Array.isArray(task.variables)) {
                task.variables.forEach(function (variable) {
                    variableSum += parseFloat(variable && variable.sell_price) || 0
                })
            }

            const bundle = (materialSum + variableSum) * safeQty

            const hourly = parseFloat(task.labour_hourly_rate) || 0
            const minuteRate = hourly / 60
            const hours = parseFloat(task.labour_time_hours) || 0
            const minutes = parseFloat(task.labour_time_minutes) || 0
            const totalMinutes = hours * 60 + minutes
            const labourCost = totalMinutes * minuteRate * safeMult * safeQty

            task.sell_price = (labourCost + bundle).toFixed(2)
            return task.sell_price
        },
        getTasks: function () {
            if (!this.subCategory || this.subCategory.id == null) return;
            this.loading = true;
            axios.post('/api/tasks/fetch/category', { id: this.subCategory.id, type: 'main' }).then(response => {
                this.tasks = response.data && response.data.default !== undefined ? response.data : { default: response.data || [], company: [] };
            }).catch(() => {
                this.tasks = { default: [], company: [] };
            });
            axios.post('/api/tasks/fetch/category', { id: this.subCategory.id, type: 'addon' }).then(response => {
                this.addons = response.data && response.data.default !== undefined ? response.data : { default: response.data || [], company: [] };
            }).catch(() => {
                this.addons = { default: [], company: [] };
            }).finally(() => {
                this.loading = false;
            });
        },
        getProducts: function () {
            if (!this.subCategory || this.subCategory.id == null) return;
            axios.get('/product/category/' + this.subCategory.id).then(response => {
                const list = response.data && response.data.products ? response.data.products : response.data
                this.products = Array.isArray(list) ? list : []
                this.products.forEach(function (item) {
                    Vue.set(item, 'qty', 0)
                })
            })
        },
        addProducts: function (products) {
            const lineItems = this.reconcileQuoteLineItems()
            for (let i = 0; i < products.length; i++) {
                if (products[i].qty > 0) {
                    products[i].cost = products[i].cost != null ? products[i].cost : 0
                    products[i].includes_gst = products[i].includes_gst != null ? products[i].includes_gst : 1
                    if (!this.existsByUuid(lineItems, products[i])) {
                        products[i].item_id = this.nextQuoteLineItemId()
                        products[i].item_type = 'product'
                        products[i].product_id = products[i].id
                        lineItems.push(products[i])
                    } else {
                        let cartProduct = this.getByUuid(lineItems, products[i])
                        cartProduct.qty += products[i].qty
                        this.updateByUuid(lineItems, cartProduct)
                    }
                }
            }
            this.spModalVisible = false
            this.quote.items = lineItems
            this.quoteItems = lineItems
            this.rightSidebarKey++
        },
        applyDefaultPriceTypeToTask: function (task) {
            if (this.defaultTaskPriceType && task && !task.price_type) {
                task.price_type = this.defaultTaskPriceType
            }
            return task
        },
        recordTaskPriceTypePreference: function (task) {
            if (task && task.price_type === TASK_PRICE_TYPES.ADDON) {
                this.defaultTaskPriceType = TASK_PRICE_TYPES.ADDON
            }
        },
        resetDefaultTaskPriceType: function () {
            this.defaultTaskPriceType = null
        },
        calculateTask: function (task, edit = false) {
            if (!edit) {
                task.calculations = []
                this.applyDefaultPriceTypeToTask(task)
            }
            this.task = task
            if (this.task.template != null || this.task.type === 2 || this.task.type === '2' || this.task.type === 'calculated') {
                this.task.template = normalizeTemplate(this.task.template, 'calculated')
            }
            if (!this.task.sell_price) {
                this.task.sell_price = 0
            }
            if(!this.task.qty) {
                this.task.qty = 1;
            }
            this.calculatedModalVisible = true
        },
        openTaskModal: function (task) {
            if (task.type === 'time_based' || task.type === 1 || task.type === 'fixed' || task.type === 3) {
                this.configureTask(task)
            } else {
                this.calculateTask(task)
            }
        },
        configureTask: function (task) {
            this.addonModalVisible = false;
            const taskClone = Object.assign({}, task);
            taskClone.qty = 1;
            taskClone.location = parseFloat(taskClone.location || taskClone.hourly_rate_multiplier || 1);
            this.applyDefaultPriceTypeToTask(taskClone);

            axios.get(`/api/tasks/materials/${taskClone.uuid}`).then(response => {
                taskClone.materials = response.data.materials
                this.task = Object.assign({}, taskClone)
                this.variablesModalVisible = true;
            });
        },
        onComparePreviewClose: function () {
            this.$store.commit('compare/setComparePreviewOpen', false)
        },
        /** Sidebar removals update quote.items; keep main.quoteItems on the same array before adds. */
        reconcileQuoteLineItems: function () {
            if (Array.isArray(this.quote.items) && this.quote.items !== this.quoteItems) {
                this.quoteItems = this.quote.items
            } else if (!Array.isArray(this.quote.items) && Array.isArray(this.quoteItems)) {
                this.quote.items = this.quoteItems
            } else if (!Array.isArray(this.quote.items)) {
                this.quote.items = []
                this.quoteItems = this.quote.items
            }
            return this.quote.items
        },
        nextQuoteLineItemId: function () {
            const lineItems = this.reconcileQuoteLineItems()
            let max = 0
            for (let i = 0; i < lineItems.length; i++) {
                const n = Number(lineItems[i].item_id)
                if (Number.isFinite(n) && n > max) {
                    max = n
                }
            }
            return max + 1
        },
        addTaskFromCompare: function (snapshot) {
            const task = Object.assign({}, snapshot)
            if (Array.isArray(snapshot.variables)) {
                task.variables = snapshot.variables
            }
            this.addTask(task)
        },
        addTask: function (addTask) {
            const lineItems = this.reconcileQuoteLineItems()
            let task = Object.assign({}, addTask);
            task.item_type = 'task'
            task.location = parseFloat(task.location || task.hourly_rate_multiplier || 1);
            task.location = task.location || task.hourly_rate_multiplier || 1;

            // Real task PK for API/DB (quote_items.item_id). Keep separate from item_id used as a line key in the UI.
            if (task.task_id == null || task.task_id === '') {
                task.task_id = task.id
            }

            var isVariablesType = task.type === 1 || task.type === 'time_based' || task.type === 3 || task.type === 'fixed';
            var isCalculatedType = isCalculatedQuoteTask(task);

            if (isVariablesType) {
                task.qty = task.qty || 1
                task.task_id = task.id
                if (!this.existsByUuid(lineItems, task)) {
                    task.item_id = this.nextQuoteLineItemId()
                    lineItems.push(task)
                } else if (!this.existsByUuidAndItemId(lineItems, task)) {
                    task.item_id = this.nextQuoteLineItemId()
                    lineItems.push(task)
                } else {
                    this.updateByUuidAndItemId(lineItems, task)
                }
                this.quote.items = lineItems
                this.quoteItems = lineItems
                this.variablesModalVisible = false
            } else if (isCalculatedType) {
                task.template = normalizeTemplate(task.template, 'calculated')
                if (!this.existsByUuid(lineItems, task)) {
                    task.qty = task.qty || 1
                    task.task_id = task.id
                    task.item_id = this.nextQuoteLineItemId()
                    lineItems.push(task)
                } else if (!this.existsByUuidAndItemId(lineItems, task)) {
                    task.qty = task.qty || 1
                    task.task_id = task.id
                    task.item_id = this.nextQuoteLineItemId()
                    lineItems.push(task)
                } else {
                    this.updateByUuidAndItemId(lineItems, task)
                }
                this.calculatedModalVisible = false
            }

            if (this.$store.getters['setting/getAccount'].price_structure === 2) {
                this.addTaskCalloutFee()
            }

            var materials = task.materials
            var needsMaterialsFetch = materials && Array.isArray(materials.default) && Array.isArray(materials.company) && materials.default.length === 0 && materials.company.length === 0 && task.uuid

            if (needsMaterialsFetch) {
                this.quote.items = lineItems
                this.quoteItems = lineItems
                var self = this
                axios.get('/api/tasks/materials/' + task.uuid).then(function (response) {
                    task.materials = response.data.materials || { default: [], company: [] }
                    self.calculateTaskCost(task)
                }).catch(function () {
                    task.materials = task.materials || { default: [], company: [] }
                }).finally(function () {
                    self.quote.items = lineItems
                    self.quoteItems = lineItems
                    self.rightSidebarKey++
                })
            } else {
                if (materials && (materials.default || materials.company)) {
                    this.calculateTaskCost(task)
                }
                this.quote.items = lineItems
                this.quoteItems = lineItems
                this.rightSidebarKey++
            }

            this.recordTaskPriceTypePreference(task)
            this.showAddons()
        },
        saveTask: function (task) {
            this.variablesModalVisible = false;
            this.editingTask = false;

            axios.get(`/api/tasks/materials/${task.uuid}`).then(response => {
                task.materials = response.data.materials
                this.calculateTaskCost(task);
            }).finally(() => {
                this.quote.items = this.quoteItems
                this.rightSidebarKey++
            });

            this.updateByUuidAndItemId(this.quoteItems, task);
            this.quote.items = this.quoteItems;
            this.rightSidebarKey++;

            this.showAddons();
        },
        showAddons: function () {
            if (this.addons.company.length === 0 && this.addons.default.length === 0) {
                return;
            }

            this.addonModalVisible = true
        },
        getQuote: function (id) {
            if (id == null || id === 'new' || String(id).trim() === '' || isNaN(Number(id))) return
            const preferredFromRoute = this.$route && this.$route.query
              ? (this.$route.query.option || this.$route.query.option_index || null)
              : null
            let preferredId = null
            let preferredIndex = preferredFromRoute
            try {
                const raw = sessionStorage.getItem('smardie_quote_active_option')
                if (raw) {
                    const parsed = JSON.parse(raw)
                    if (parsed && Number(parsed.quoteId) === Number(id)) {
                        preferredId = parsed.optionId || null
                        if (preferredIndex == null && parsed.optionIndex != null) {
                            preferredIndex = parsed.optionIndex
                        }
                    }
                    sessionStorage.removeItem('smardie_quote_active_option')
                }
            } catch (_) { /* ignore */ }

            const params = {}
            if (preferredIndex != null) params.option = preferredIndex
            if (preferredId != null) params.option_id = preferredId

            axios.get('/quote/' + id, { params }).then(response => {
                const data = response.data
                this.quote = data.quote || data
                this.quote.discount_override = (data.quote || data).discount_amount_applied || (data.quote || data).discount || 0
                this.quote.discount_mode = (data.quote || data).discount_mode || null
                this.quote.discount_preset_id = (data.quote || data).discount_preset_id || null
                this.quote.discount_title = (data.quote || data).discount_title || null
                this.quote.discount_description = (data.quote || data).discount_description || null
                this.quote.discount_type = (data.quote || data).discount_type || null
                this.quote.discount_value = (data.quote || data).discount_value || null
                this.quote.discount_amount_applied = (data.quote || data).discount_amount_applied || 0
                if (!this.quote.terms && this.quote.notes) {
                    this.quote.terms = this.quote.notes
                }
                if (!this.quote.contact || !this.quote.contact.id) {
                    const contactCompany = this.quote.contact_company || this.quote.contact_name || this.quote.company_name || ''
                    this.quote.contact = {
                        id: this.quote.contact_id,
                        email: this.quote.contact_email || '',
                        first_name: this.quote.contact_first_name || '',
                        last_name: this.quote.contact_last_name || '',
                        company: contactCompany
                    }
                }
                if (!this.quote.due_date) {
                    this.quote.due_date = this.quote.valid_until || (this.quote.created_at
                        ? addDaysYmd(this.quote.created_at, this.quoteValidityDays)
                        : null)
                }
                // Freeze last-saved option snapshots for dirty detection in preview
                if (Array.isArray(this.quote.options) && this.quote.options.length) {
                    this.$set(this.quote, '_savedOptionBaselines', deepClone(this.quote.options))
                }
                // Prefer the option the user had selected in preview (route/session/API)
                this.applyPreferredQuoteOption(preferredId, preferredIndex)
                const rawItems = this.quote.items || []
                this.quoteItems = rawItems.map(item => {
                    const itemType = item.item_type === 'material' ? 'product' : item.item_type
                    const qtyRaw = item.qty != null ? item.qty : (item.quantity != null ? item.quantity : 1)
                    const qtyNum = Number(qtyRaw)
                    const sellPrice = item.sell_price != null ? item.sell_price : (item.unit_price != null ? item.unit_price : 0)
                    const labourHours = item.labour_time_hours != null ? item.labour_time_hours : (item.labour_hours != null ? item.labour_hours : 0)
                    const labourMinutes = item.labour_time_minutes != null ? item.labour_time_minutes : (item.labour_minutes != null ? item.labour_minutes : 0)
                    const location = item.location != null ? item.location : (item.hourly_rate_multiplier != null ? item.hourly_rate_multiplier : 1)
                    return Object.assign({}, item, {
                        item_type: itemType,
                        // Qty should always be whole on the quote/invoice.
                        qty: Number.isFinite(qtyNum) && qtyNum > 0 ? Math.round(qtyNum) : 1,
                        sell_price: sellPrice,
                        categories: Array.isArray(item.categories) ? item.categories : [],
                        labour_time_hours: labourHours,
                        labour_time_minutes: labourMinutes,
                        location
                    })
                })
                this.quote.items = this.quoteItems
            }).catch(() => {})
        },
        applyPreferredQuoteOption: function (preferredId, preferredIndex) {
            const options = Array.isArray(this.quote.options) ? this.quote.options : []
            if (!options.length) return
            let active = null
            if (preferredId != null && preferredId !== '') {
                active = options.find((o) => o.id === Number(preferredId) || o.id === preferredId) || null
            }
            if (!active && this.quote.active_option_id) {
                active = options.find((o) => o.id === this.quote.active_option_id) || null
            }
            if (!active && preferredIndex != null && preferredIndex !== '') {
                const idx = Number(preferredIndex)
                if (Number.isFinite(idx)) {
                    active = options.find((o) => o.option_index === idx) || null
                }
            }
            if (!active && this.quote.active_option_index) {
                active = options.find((o) => o.option_index === Number(this.quote.active_option_index)) || null
            }
            if (!active) active = options[0]
            if (!active) return
            this.$set(this.quote, 'active_option_id', active.id)
            this.$set(this.quote, 'active_option_index', active.option_index)
            if (Array.isArray(active.items)) {
                this.quote.items = deepClone(active.items)
                this.quoteItems = this.quote.items
            }
            if (active.discount_mode !== undefined) this.quote.discount_mode = active.discount_mode
            if (active.discount_preset_id !== undefined) this.quote.discount_preset_id = active.discount_preset_id
            if (active.discount_title !== undefined) this.quote.discount_title = active.discount_title
            if (active.discount_description !== undefined) this.quote.discount_description = active.discount_description
            if (active.discount_type !== undefined) this.quote.discount_type = active.discount_type
            if (active.discount_value !== undefined) this.quote.discount_value = active.discount_value
            if (active.discount_amount_applied !== undefined) {
                this.quote.discount_amount_applied = active.discount_amount_applied || 0
                this.quote.discount_override = active.discount_amount_applied || 0
            }
            if (active.total != null) {
                this.quote.total = active.total
                this.quote.total_amount = active.total
            }
            if (active.reference !== undefined) {
                this.$set(this.quote, 'reference', active.reference != null ? active.reference : '')
            }
        },
        getTaskCount: function () {
            let count = 0
            for (let i = 0; i < this.quoteItems.length; i++) {
                if (this.quoteItems[i].item_type === 'task') {
                    if (this.excludedFromSmartPricing(this.quoteItems[i]) === false) {
                        count += this.quoteItems[i].qty
                    }
                }
            }
            return count
        },
        addTaskCalloutFee: function () {
            let callout = this.$store.getters['setting/getAccount'].callout_fee / this.getTaskCount()
            for (let i = 0; i < this.quoteItems.length; i++) {
                if (this.quoteItems[i].item_type === 'task') {
                    if (this.excludedFromSmartPricing(this.quoteItems[i]) === false) {
                        this.quoteItems[i].callout_fee = callout
                    }
                }
            }
        },
        existsByUuid(array, object) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].uuid === object.uuid) {
                    return true
                }
            }
            return false
        },
        existsByUuidAndItemId(array, object) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].uuid === object.uuid) {
                    if (array[i].item_id === object.item_id) {
                        return true
                    }
                }
            }
            return false
        },
        updateByUuid(array, object) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].uuid === object.uuid) {
                    array[i] = object
                }
            }
            return array
        },
        updateByUuidAndItemId(array, object) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].uuid === object.uuid) {
                    if (array[i].item_id === object.item_id) {
                        array[i] = object
                    }
                }
            }
            return array
        },
        getByUuid(array, object) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].uuid === object.uuid) {
                    return array[i]
                }
            }
        },
        start: function (data) {
            this.quote.contact    = data.contact;
            this.quote.contact_id = data.contact.id;
            if (data.service_m8_job) {
              this.quote.service_m8_job_id     = data.service_m8_job.uuid;
              this.quote.service_m8_job_number = String(data.service_m8_job.generated_job_id);
            } else {
              this.quote.service_m8_job_id     = null;
              this.quote.service_m8_job_number = null;
            }
            this.customerModalVisible = false;
        },
        /** Keep main.quoteItems aligned when the sidebar normalizes or mutates line items. */
        onRightbarLineItemsSync: function (items) {
            this.quote.items = items
            this.quoteItems = items
        },
        saveLocally: function () {
            if (this.quote.number === null && this.quote.total !== 0) {
                localStorage.setItem('quote', JSON.stringify(this.quote))
            } else {
                localStorage.removeItem('quote')
            }
        },
        excludedFromSmartPricing: function (task) {
            if (!task || !Array.isArray(task.categories)) return false
            for (let i = 0; i < task.categories.length; i++) {
                if (task.categories[i].id === 35 || task.categories[i].id === 36 || task.categories[i].id === 38 || task.categories[i].id === 250) {
                    return true
                }
            }
            return false
        },
        taskHasVariableOptions: function (task) {
            if (!task || !task.variables || typeof task.variables !== 'object') return false
            const d = task.variables.default
            const c = task.variables.company
            return (Array.isArray(d) && d.length > 0) || (Array.isArray(c) && c.length > 0)
        },
        isTimeBasedType: function (task) {
            return task && (task.type === 1 || task.type === 'time_based')
        },
        isFixedType: function (task) {
            return task && (task.type === 3 || task.type === 'fixed')
        },
        /** Same as Variables.vue `effectiveMultiplier` — catalog tiles must use this, not 1.0x. */
        effectiveTaskMultiplier: function (task) {
            if (!task) return 1
            const loc = task.location
            const hrm = task.hourly_rate_multiplier
            const raw = (loc != null && loc !== '')
                ? parseFloat(loc)
                : (hrm != null && hrm !== '' ? parseFloat(hrm) : NaN)
            return Number.isFinite(raw) && raw > 0 ? raw : 1
        },
        catalogPreviewPrice: function (task) {
            if (!task) return null
            const ct = task.type
            if (ct === 2 || ct === '2' || ct === 'calculated') return null
            if (this.taskHasVariableOptions(task)) return null
            if (this.isFixedType(task)) {
                const sp = parseFloat(task.sell_price)
                return (Number.isFinite(sp) && sp > 0) ? Number(sp).toFixed(2) : null
            }
            if (this.isTimeBasedType(task)) {
                const sellRaw = task.sell_price != null && task.sell_price !== '' ? parseFloat(task.sell_price) : NaN
                if (Number.isFinite(sellRaw) && sellRaw > 0) return sellRaw.toFixed(2)
                const mult = this.effectiveTaskMultiplier(task)
                const clone = Object.assign({}, task, { qty: 1, location: mult, hourly_rate_multiplier: mult })
                clone.sell_price = 0
                const out = this.calculateTaskCost(clone)
                return out != null && out !== '' ? String(out) : null
            }
            return null
        },
        loadQuoteCategories: function () {
            this.loadingCategories = true
            axios.get('/api/categories').then(response => {
                const flat = response.data.flat_categories || []
                const hierarchical = response.data.categories || []
                store.commit('category/setAll', flat)
                const topLevel = hierarchical.length ? hierarchical : flat.filter(function (c) { return c.parent_id === null || c.parent_id === 0 })
                store.commit('category/setCategories', topLevel)
                this.categoryTiles = topLevel
            }).catch(function () {
                store.commit('category/setAll', [])
                store.commit('category/setCategories', [])
                this.categoryTiles = []
            }).finally(() => {
                this.loadingCategories = false
            })
        },
        onCategoryTileClick: function (cat) {
            const self = this
            this.catalogViewMode = 'browse'
            this.catalogSearchText = ''
            axios.get('/api/categories/' + cat.id).then(function (response) {
                const children = (response.data.category && response.data.category.children) || response.data.sub_categories || []
                self.breadcrumbSegments = self.breadcrumbSegments.concat([{ id: cat.id, name: cat.name }])
                if (children.length > 0) {
                    self.categoryTiles = children
                    self.subCategory = null
                } else {
                    self.categoryTiles = []
                    self.subCategory = cat
                }
            }).catch(function () {})
        },
        navigateBreadcrumbTo: function (idx) {
            const self = this
            const seg = this.breadcrumbSegments[idx]
            if (!seg) return
            this.catalogViewMode = 'browse'
            this.catalogSearchText = ''
            axios.get('/api/categories/' + seg.id).then(function (response) {
                const children = (response.data.category && response.data.category.children) || response.data.sub_categories || []
                self.breadcrumbSegments = self.breadcrumbSegments.slice(0, idx + 1)
                if (children.length > 0) {
                    self.categoryTiles = children
                    self.subCategory = null
                } else {
                    self.categoryTiles = []
                    self.subCategory = seg
                }
            }).catch(function () {})
        },
        goToAllCategories: function () {
            this.catalogViewMode = 'browse'
            this.catalogSearchText = ''
            this.breadcrumbSegments = []
            this.subCategory = null
            this.tasks = { default: [], company: [] }
            const top = this.$store.getters['category/getCategories']
            if (top && top.length) {
                this.categoryTiles = top
            } else {
                this.loadQuoteCategories()
            }
        },
        closeTaskModals: function () {
            this.calculatedModalVisible = false
            this.variablesModalVisible = false
            this.addonModalVisible = false
            this.editingTask = false
        },
        onTaskModalBreadcrumbNavigateAll: function () {
            this.closeTaskModals()
            this.goToAllCategories()
        },
        onTaskModalBreadcrumbNavigateSegment: function (idx) {
            this.closeTaskModals()
            this.navigateBreadcrumbTo(idx)
        },
        runCatalogSearch: function () {
            const q = (this.catalogSearchText || '').trim()
            if (q.length < 2) {
                if (this.swal) {
                    this.swal({ type: 'info', title: 'Search', text: 'Enter at least 2 characters to search.' })
                }
                return
            }
            this.catalogViewMode = 'search'
            this.breadcrumbSegments = []
            this.subCategory = null
            this.categoryTiles = []
            this.loading = true
            const self = this
            axios.post('/api/tasks/fetch/search', { text: q }).then(function (res) {
                const items = (res.data && res.data.items) ? res.data.items : []
                self.tasks = { default: items, company: [] }
            }).catch(function () {
                self.tasks = { default: [], company: [] }
            }).finally(function () {
                self.loading = false
            })
        },
        stopSpeechRecognition: function () {
            clearTimeout(this._speechMaxTimer)
            this._speechMaxTimer = null
            this.speechRecording = false
            if (this._speechRec) {
                try {
                    this._speechRec.stop()
                } catch (e) {}
                this._speechRec = null
            }
        },
        toggleSpeechInput: function () {
            if (!this.speechRecognitionAvailable) return
            if (this.speechRecording && this._speechRec) {
                this.stopSpeechRecognition()
                return
            }
            const SR = window.SpeechRecognition || window.webkitSpeechRecognition
            const rec = new SR()
            const self = this
            this._speechRec = rec
            rec.lang = 'en-AU'
            rec.continuous = false
            rec.interimResults = false
            const MAX_MS = 45000
            rec.onstart = function () {
                self.speechRecording = true
                clearTimeout(self._speechMaxTimer)
                self._speechMaxTimer = setTimeout(function () {
                    self.stopSpeechRecognition()
                }, MAX_MS)
            }
            rec.onend = function () {
                clearTimeout(self._speechMaxTimer)
                self._speechMaxTimer = null
                self.speechRecording = false
                self._speechRec = null
            }
            rec.onerror = function () {
                clearTimeout(self._speechMaxTimer)
                self._speechMaxTimer = null
                self.speechRecording = false
                self._speechRec = null
            }
            rec.onresult = function (event) {
                if (event.results && event.results[0] && event.results[0][0]) {
                    self.catalogSearchText = event.results[0][0].transcript
                }
            }
            try {
                rec.start()
            } catch (e) {
                this.stopSpeechRecognition()
            }
        },
        updateNarrowScreen: function () {
            if (typeof window === 'undefined' || !window.matchMedia) return
            this.isNarrowScreen = window.matchMedia('(max-width: 767px)').matches
        },
        scrollTasksToTop() {
            let element = document.getElementsByClassName('tasks')[0]
            if (element) element.scrollTop = 0
        }
    },
    watch: {
        subCategory: function () {
            this.tasks = {
                default: [],
                company: []
            }
            this.products = {
                default: [],
                company: []
            }
            this.addons = {
                default: [],
                company: []
            }
            if (this.subCategory) {
                this.getTasks()
                this.getProducts()
            }
            this.scrollTasksToTop()
        }
    },
    created: function () {
        /**
         * Component requires authentication, check if user is authenticated
         */
        auth.check(this)

        axios.get('/api/setting/display').then(response => {
            this.quoteValidityDays = quoteValidityDaysFromSettings(response.data)
            // New quote: apply company default expiry if still on the provisional module default
            if (!this.quote.id && !this.quote.valid_until) {
                const provisional = addDaysYmd(today, DEFAULT_QUOTE_VALIDITY_DAYS)
                if (!this.quote.due_date || this.quote.due_date === provisional || this.quote.due_date === dueDefault) {
                    this.quote.due_date = addDaysYmd(this.quote.date || today, this.quoteValidityDays)
                }
            }
        }).catch(() => {})

        setInterval(this.saveLocally, 60000)

        store.commit('setFooter', false)
        document.body.id = 'newQuote'
        document.body.className = 'dimmable'
    },
    unmounted: function () {
        this.resetDefaultTaskPriceType()
        if (this._speechVisibilityHandler) {
            document.removeEventListener('visibilitychange', this._speechVisibilityHandler)
            this._speechVisibilityHandler = null
        }
        this.stopSpeechRecognition()
        if (this._mediaQuery && this._mediaHandler) {
            if (this._mediaQuery.removeEventListener) {
                this._mediaQuery.removeEventListener('change', this._mediaHandler)
            } else if (this._mediaQuery.removeListener) {
                this._mediaQuery.removeListener(this._mediaHandler)
            }
        }
        store.commit('setFooter', true)
        document.body.id = ''
        document.body.className = ''
    },
    mounted: function () {
        const routeId = this.$route.params.id
        const isNewQuote = this.$route.name === 'NewQuote' || this.$route.path === '/quote/new' || routeId === 'new'
        if (routeId && !isNewQuote && String(routeId).trim() !== '' && !isNaN(Number(routeId))) {
            this.getQuote(routeId)
        } else if (!routeId || isNewQuote) {
            let savedQuote = localStorage.getItem('quote')

            if (savedQuote !== null) {
                this.quote = JSON.parse(savedQuote)
                const restored = Array.isArray(this.quote.items) ? this.quote.items : []
                this.quote.items = restored
                this.quoteItems = restored
                this.rightSidebarKey++
                this.swal({
                    type: 'info',
                    title: 'Unsaved Quote',
                    text: 'We found an unsaved quote, do you want to complete it?',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#4DA1FF',
                    confirmButtonText: 'Clear',
                    cancelButtonText: 'Continue'
                }).then((result) => {
                    if (result.value) {
                        localStorage.removeItem('quote')
                        location.reload()
                    }
                })
            } else {
                this.customerModalVisible = true
            }
        }

        $(this.$el).find('.ui.sticky').sticky({
            context: '#sidebar'
        })

        this.updateNarrowScreen()
        this._mediaHandler = this.updateNarrowScreen
        if (typeof window !== 'undefined' && window.matchMedia) {
            this._mediaQuery = window.matchMedia('(max-width: 767px)')
            if (this._mediaQuery.addEventListener) {
                this._mediaQuery.addEventListener('change', this._mediaHandler)
            } else if (this._mediaQuery.addListener) {
                this._mediaQuery.addListener(this._mediaHandler)
            }
        }

        this.loadQuoteCategories()

        const self = this
        this._speechVisibilityHandler = function () {
            if (document.hidden) self.stopSpeechRecognition()
        }
        document.addEventListener('visibilitychange', this._speechVisibilityHandler)
    }
}
</script>

<style>
/* Clear fixed app header — quote builder root is .main.ui.container */
.main.ui.container {
    margin-top: 48px !important;
}
</style>
